import { forwardRef, useId } from "react";
import { Button } from "react-daisyui";
import { IconX } from "@tabler/icons-react";
import { Heading } from "src/core/components/Heading";
import { Dialog } from "src/core/components/dialog/Dialog";
import { SanitisedHtml } from "src/core/components/SanitisedHtml";
import { DateDisplay } from "src/core/components/data/DateDisplay";
import { usePrivacyPolicy } from "src/core/church/useChurchTexts";

interface Props {
    /** Fetches the policy only once the dialog has been opened */
    opened: boolean;
}

export const PrivacyPolicyDialog = forwardRef<HTMLDialogElement, Props>(({ opened }, ref) => {
    const { policy, error } = usePrivacyPolicy(opened);
    const headingId = useId();

    return (
        <Dialog ref={ref} aria-labelledby={headingId} className="text-left" responsive>
            <Dialog.Body>
                <form method="dialog">
                    <Dialog.Header className="flex">
                        <Heading level="h4" id={headingId} className="grow">
                            Privacy policy
                        </Heading>

                        <Button startIcon={<IconX />} color="ghost" size="sm">
                            <span className="hidden">Close</span>
                        </Button>
                    </Dialog.Header>

                    {policy ? (
                        <>
                            <p className="text-sm opacity-75 mb-4">
                                Last updated <DateDisplay date={policy.publishedAt} format="LONG" />
                            </p>

                            <SanitisedHtml html={policy.body} className="prose overflow-auto" />
                        </>
                    ) : error ? (
                        <p>There was an error loading the privacy policy. Try again, or contact the church for help.</p>
                    ) : (
                        <span className="loading loading-spinner" />
                    )}

                    <Dialog.Actions>
                        <Button formMethod="dialog">Close</Button>
                    </Dialog.Actions>
                </form>
            </Dialog.Body>
        </Dialog>
    );
});
